import { useState } from 'react'
import { portalLogos, getPortalInfo } from '../../constants/integracoes'

interface PortalLogoProps {
  portal: string
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const sizeClasses = {
  sm: 'w-6 h-6',
  md: 'w-8 h-8',
  lg: 'w-10 h-10',
}

export default function PortalLogo({
  portal,
  size = 'md',
  className = ''
}: PortalLogoProps) {
  const [imageError, setImageError] = useState(false)
  const portalUpper = portal.toUpperCase()
  const logoUrl = portalLogos[portalUpper]
  const portalInfo = getPortalInfo(portalUpper)
  const displayName = portalInfo?.nome || portal
  const sizeClass = sizeClasses[size]

  const handleImageError = () => {
    setImageError(true)
  }

  // Se não há logo ou houve erro, mostra a inicial com fundo cinza
  if (!logoUrl || imageError) {
    return (
      <div className={`${sizeClass} rounded-lg bg-gray-200 flex items-center justify-center ${className}`}>
        <span className="text-gray-600 font-bold text-sm">
          {displayName.charAt(0)}
        </span>
      </div>
    )
  }

  return (
    <img
      src={logoUrl}
      alt={displayName}
      className={`${sizeClass} object-contain ${className}`}
      onError={handleImageError}
    />
  )
}
